import {
    FETCH_POPUP_FAILURE,
    FETCH_POPUP_SUCCESS,
    FETCH_POPUP_REQUEST,
    FETCH_ACTIVE_POPUP_REQUEST,
    FETCH_PUBLISH_POPUP_REQUEST,
    FETCH_CREATE_NEW_POPUP_REQUEST,
    FETCH_POPUP_ID_REQUEST
} from "./actionTypes"
import {
    FetchPopupFailure,
    FetchPopupFailurePayload,
    FetchPopupSuccess,
    FetchPopupRequest,
    FetchPopupSuccessPayload,
    FetchPopupActiveRequest,
    FetchPopupPublishRequest,
    FetchCreateNewPopupRequest,
    FetchPopupIdRequest
} from "./types"

export const fetchPopupRequest = (obj: any): FetchPopupRequest =>({
    type: FETCH_POPUP_REQUEST,
    params: obj.params,
    id: obj.id,
    active: obj.active
})
export const fetchPopupSuccess = (
    payload: FetchPopupSuccessPayload
): FetchPopupSuccess => ({
    type: FETCH_POPUP_SUCCESS,
    payload,
})
export const fetchPopupFailure = (
    payload: FetchPopupFailurePayload
): FetchPopupFailure => ({
    type: FETCH_POPUP_FAILURE,
    payload,
})

export const fetchActivePopupRequest =(obj: any): FetchPopupActiveRequest =>({
    type: FETCH_ACTIVE_POPUP_REQUEST,
    id: obj.id
})
export const fetchPublishPopupRequest = (obj:any) : FetchPopupPublishRequest =>({
    type: FETCH_PUBLISH_POPUP_REQUEST,
    params: obj.params
})
export const fetchCreateNewPopupRequest = (obj: any): FetchCreateNewPopupRequest =>({
    type: FETCH_CREATE_NEW_POPUP_REQUEST,
    body: obj.body,
})
export const fetchPopupIdRequest = (obj: any): FetchPopupIdRequest =>({
    type: FETCH_POPUP_ID_REQUEST,
    params: obj.params,
})